import { useMeContext } from '@shared/contexts/hooks/useMeContext';
import { useConversationActionExecutionUpdatedSubscription } from '@shared/generated/graphql';
import { useEffect, useRef } from 'react';

const ACTION_EXECUTION_UPDATE_REFETCH_DELAY_MS = 1000;

export function useRefetchOnActionExecutionUpdates(
  conversationIds: string[],
  refetch: () => Promise<unknown>
): void {
  const { defaultOrgId } = useMeContext();
  const refetchRef = useRef(refetch);
  refetchRef.current = refetch;
  const refetchTimeout = useRef<ReturnType<typeof setTimeout> | undefined>(
    undefined
  );

  useConversationActionExecutionUpdatedSubscription({
    skip: !defaultOrgId || conversationIds.length === 0,
    variables: { conversationIds, organizationId: defaultOrgId ?? '' },
    onData: () => {
      if (refetchTimeout.current !== undefined) return;
      refetchTimeout.current = setTimeout(() => {
        refetchTimeout.current = undefined;
        refetchRef.current().catch(console.error);
      }, ACTION_EXECUTION_UPDATE_REFETCH_DELAY_MS);
    },
  });

  useEffect(
    () => () => {
      clearTimeout(refetchTimeout.current);
      refetchTimeout.current = undefined;
    },
    []
  );
}
